import type { HucreDegeri } from '../rapor-ekrani/kolon';

/** Borç / alacak işareti: B kırmızı, A yeşil, bakiyesiz "-". Değer `bicim.borcAlacak` çıktısıdır. */
export function BaIsareti({ deger }: { deger: HucreDegeri }) {
  if (deger === 'B') return <span className="rt-borc">B</span>;
  if (deger === 'A') return <span className="rt-alacak">A</span>;
  return <span>-</span>;
}
